"use client";

import { Container } from "@/components/ui/container";
import DesignerCard from "@/components/entities/designer-card";
import S from "./index.module.scss";
import { useDesignersData } from "@/views/design/hooks/useDesignersData";

const DesignersMain = () => {
  const { designers, loadingDesigners } = useDesignersData();

  if (loadingDesigners || !designers) return null;

  return (
    <Container>
      <div className={S.designersGrid}>
        {designers.designs?.map((designer, idx) => (
          <DesignerCard {...designer} key={idx} />
        ))}
      </div>
    </Container>
  );
};

export default DesignersMain;
